import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Container, ListGroup, ListGroupItem } from 'reactstrap';
import { AppContext } from '../../../context/app-context';
import { planType, dietaryPreference, preferredCuisine, dietaryPreferenceWithout, preferredCuisineWithout, allergiesType } from '../../../context/staticData';
import AssessmentHeader from '../../Diet/component/AssessmentHeader';
import RadioButton from '../../Diet/component/RadioButton';
import { useDiet } from '../../../hooks/useDiet';
import { sendFirebaseEvent } from '../../../helper/mobile';
import vegNonVeg from '../../../assets/images/veg-nonveg.svg'
import fruitBasket from '../../../assets/images/fruit-basket.svg'
import CheckBox from '../../Diet/component/CheckBox';
import { Country, State, City }  from 'country-state-city';


const PlanType = () => {

  let navigate = useNavigate();
  const location = useLocation();

  const { generateAssessment } = useDiet();
  const [state, dispatch] = useContext(AppContext);
  const [selectedPlanType, setSelectedPlanType] = useState();
  const [typeSelect, setTypeSelect] = useState();
  const [checkboxList, setCheckboxList] = useState(state.assessment.allergies);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectdCountry, setSelectdCountry] = useState('IN');
  const [selectdState, setSelectdState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectdCountryName, setSelectdCountryName] = useState('India');
  const [selectdStateName, setSelectdStateName] = useState('');
  const [selectedCityName, setSelectedCityName] = useState('');

  
  const PAGE_INFO = {
    "planType": {
      name: 'planType',
      url: 'allergies',
      progressPer: '50',
      btnText: 'Next',
      list: planType,
      title: 'Choose a plan that will help you achieve your goal'
    },
    "allergies": {
      name: 'Allergies',
      url: 'address',
      progressPer: '63',
      btnText: 'Next',
      multiSelectList: allergiesType,     
      title: 'Allergy',
      subHeading:'Do you have any allergies or dietary restrictions?',
    },
    "address": {
      name: 'Address',
      url: 'dietaryPreference',
      progressPer: '70',
      btnText: 'Next', 
      address:'address',
      title: 'Address',
      subHeading:'Select your Country, State and City',
    },
    "dietaryPreference": {
      name: 'dietaryPreference',
      url: 'preferredCuisine',
      progressPer: '75',
      btnText: 'Next',
      list: dietaryPreferenceWithout,
      title: 'What is your meal preference?',
      subHeading:'These are critical conditions. What would you want your plan to focus on?',
      image:vegNonVeg
    },
    "preferredCuisine": {
      name: 'preferredCuisine',
      url: 'dietPlanAnalyzing',
      progressPer: '100',
      btnText: 'Suggest me a plan',
      list: preferredCuisineWithout,
      title: 'What is your cuisine preference?',
      subHeading:'These are critical conditions. What would you want your plan to focus on?',
      image:fruitBasket
    }, 
  }

  useEffect(() => {
    if(location.pathname.includes('planType')){
      setTypeSelect(PAGE_INFO['planType']);
      if(state.assessment.planType !== '')
        setSelectedPlanType(state.assessment.planType)
      else
        setSelectedPlanType();
    }
    else if(location.pathname.includes('allergies')){
      setTypeSelect(PAGE_INFO['allergies']);
      if(state.assessment.allergies !== '')
        setSelectedPlanType(state.assessment.allergies)
      else
        setSelectedPlanType();
    }
    else if(location.pathname.includes('address')){
      setCountries(Country.getAllCountries());
      setStates(State.getStatesOfCountry('IN'));
      setTypeSelect(PAGE_INFO['address']);
      if(state.assessment.address.country !== undefined){
        setStates(State.getStatesOfCountry(selectdCountry));
        setCities(City.getCitiesOfState(selectdCountry,state.assessment.address.state));
        setSelectedPlanType(state.assessment.address)
        setSelectdCountry(state.assessment.address.country);
        setSelectdState(state.assessment.address.state);
        setSelectedCity(state.assessment.address.city);
      }
      else
        setSelectedPlanType();
    }
    else if(location.pathname.includes('dietaryPreference')){
      setTypeSelect(PAGE_INFO['dietaryPreference']);
      if(state.assessment.dietaryPreference !== '')
        setSelectedPlanType(state.assessment.dietaryPreference)
      else
        setSelectedPlanType();
    }
    else if(location.pathname.includes('preferredCuisine')){
      setTypeSelect(PAGE_INFO['preferredCuisine']);
      if(state.assessment.preferredCuisine !== '')
        setSelectedPlanType(state.assessment.preferredCuisine)
      else
        setSelectedPlanType();
    }
  }, [location]);

  const handleOnChange = (event, option) => {
    setSelectedPlanType(event.target.value);
    let payloadLet;
    if (location.pathname.includes('planType'))
      payloadLet = { planType: event.target.value };
    else if (location.pathname.includes('allergies')) {
      checkboxList.push(option)
      setCheckboxList((prev) => {
        return [...prev, option];
      });

      checkboxList.forEach(chkItem => {
        if (option.label === 'None') {
          if (chkItem.label === 'None')
            chkItem.isChecked = event.target.checked;
          else
            chkItem.isChecked = false;
        }
        else {
          if (chkItem === option)
            chkItem.isChecked = event.target.checked;
          if (chkItem.label === 'None')
            chkItem.isChecked = false;
        }

      })
      payloadLet = { allergies: Array.from(new Set(checkboxList)).filter((list)=> list.isChecked).map((list)=>list.value) };
      
    }

    else if(location.pathname.includes('address')){
      switch(option){
        case'counrty':
        setSelectdCountry(event.target.value);
        setSelectdState('');
        setSelectedCity('');
        setStates(State.getStatesOfCountry(event.target.value));
        setSelectdCountryName(event.target[event.target.selectedIndex].label);
        payloadLet ={ address: {
          country:event.target.value,
          state:'',
          city:''
        }};
        break;
        case'state':
        setSelectdState(event.target.value)
        setCities(City.getCitiesOfState(selectdCountry,event.target.value));
        setSelectdStateName(event.target[event.target.selectedIndex].label);
        setSelectedCity('');
        payloadLet ={ address: {
          country:selectdCountry,
          state:event.target.value,
          city:''
        }};
       
        break;
        case'city':
        setSelectedCity(event.target.value);
        setSelectedCityName(event.target[event.target.selectedIndex].label);
        payloadLet = { address:{
          country:selectdCountry,
          state:selectdState,
          city:event.target.value
        }};
        break;
        default:
        break;
      }


    }



    else if (location.pathname.includes('dietaryPreference'))
      payloadLet = { dietaryPreference: event.target.value };
    else if(location.pathname.includes('preferredCuisine'))
      payloadLet = { preferredCuisine:event.target.value };
    dispatch({
      type: "ASSESSMENT",
      payload: payloadLet
    });
}

  const handleOnClick = (url) => {
    if(url === 'dietPlanAnalyzing') {
      let healthConditions=[];
      state.healthConditions.filter(obj => {
        if(obj.isChecked === true){
          healthConditions = [...healthConditions, {
            "heathConditionLabel": obj.label,
            "heathConditionValue": obj.value
          }]
        }
      });
      let reqData = {
        planType: state.assessment.planType,
        preferredCuisine: state.assessment.preferredCuisine,
        allergies: state.assessment.allergies,
        userLocation:`${selectedCityName}, ${selectdStateName}, ${selectdCountryName}`,
        dietaryPreference: state.assessment.dietaryPreference,

      }
      let activatePlan = localStorage.getItem("activatePlan");

      if(activatePlan==null){
        activatePlan = false;
        localStorage.setItem("activatePlan",false)
      }
      if(healthConditions.length > 0) {
        reqData = {...reqData, ...{healthConditions: healthConditions}}
      }
      sendFirebaseEvent('diet_plan_suggest_me_plan_btn', 'click_event');
      
      generateAssessment(reqData, activatePlan)
    }else {
      console.log("URL-->", url)
      navigate(`/dietPlan/${url}`);
    }
  }

  return (
    <>
      <AssessmentHeader progressPer={typeSelect?.progressPer} />
      <Container className='diet-container'>
      <div className='img-container mt-5 mb-3'>
      <img src={typeSelect?.image} alt=''/>
      </div>
      <h4 className='header-text'>{typeSelect?.title}</h4>
        <h2 className='assessment-page-title'>{typeSelect?.subHeading}</h2>
        {typeSelect?.list && <div className='d-flex flex-column min-vh-40 justify-content-center align-items-center'>
          {typeSelect && <RadioButton radioList={typeSelect.list} selectedPlanType={selectedPlanType} onClickRadio={handleOnChange} />}
        </div>}

        {typeSelect?.multiSelectList &&
          <CheckBox
            checkboxList={typeSelect.multiSelectList}
            onChange={handleOnChange}
          />}

        {typeSelect?.address &&
          <select onChange={e => handleOnChange(e, 'counrty')} className="form-select mb-4 rounded-pill" aria-label="Default select example">
            <option defaultValue={''}>Select your counrty</option>
            {countries.map((obj, i) => {
              if (obj.isoCode === selectdCountry && selectdCountry !== '') {
                return <option counrtyname={obj.name} selected key={obj.isoCode} value={obj.isoCode}>{obj.name}</option>
              } else {
                return <option counrtyname={obj.name} key={obj.isoCode} value={obj.isoCode}>{obj.name}</option>
              }
            })}
          </select>
        }

        {typeSelect?.address &&
          <select onChange={e => handleOnChange(e, 'state')} className="form-select mb-4 rounded-pill" aria-label="Default select example">
            <option>Select your state</option>
            {states.map((obj, i) => {
              if (obj.isoCode === selectdState && selectdState !== '') {
                return <option selected key={obj.isoCode} value={obj.isoCode}>{obj.name}</option>
              } else {
                return <option key={obj.isoCode} value={obj.isoCode}>{obj.name}</option>
              }
            })}
          </select>
        }

        {typeSelect?.address &&
          <select onChange={e => handleOnChange(e, 'city')} className="form-select mb-4 rounded-pill" aria-label="Default select example">
            <option>Select your city</option>
            {cities.map((obj, i) => {
              if (obj.name === selectedCity && selectedCity !== '') {
                return <option selected key={obj.name} value={obj.name}>{obj.name}</option>
              } else {
                return <option key={obj.name} value={obj.name}>{obj.name}</option>
              }
            })}
          </select>
        }
        <Button className='diet-payment-btn btn-diet-done' onClick={() => handleOnClick(typeSelect?.url)} disabled={selectedPlanType ? false : true}>{typeSelect?.btnText}</Button>
      </Container>
    </>
  );
}

export default PlanType;